﻿export default class Accordion {

  listSelector = '[data-js-accordion]';
  itemSelector = '[data-js-accordion-item]';
  itemButtonSelector = '.content-accordion__item__title > button';
  expandedClass = 'content-accordion__item--expanded';
  initExpandedClass = 'content-accordion__item--init-expansion';

  constructor() {
    this.setupAccordions();
  }

  setupAccordions() {
    const elements = getElementList(document, this.listSelector);

    elements.forEach(element => {
      this.setupAccordion(element);
    });
  }

  setupAccordion(list) {

     const elements = getElementList(list, this.itemSelector);

      elements.forEach(element => {

      const button = element.querySelector(this.itemButtonSelector);

        button.addEventListener('click', () => {

        if (element.classList.contains(this.expandedClass)) {
          this.collapseItem(element);
        } else {
          this.collpaseAllItems(list);
          this.expandItem(element);
        }
      })
    })
  }

    expandItem(element) {

        const button = element.querySelector('.content-accordion__item button');

    if (button) {
      button.setAttribute('aria-expanded', 'true');
    }

    element.classList.add(this.expandedClass, this.initExpandedClass);

    setTimeout(() => {
      element.classList.remove(this.initExpandedClass);
    }, 100)
  }

  collapseItem(element) {
    element.classList.remove(this.expandedClass);

      const button = element.querySelector('.content-accordion__item button');
    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
  }

  collpaseAllItems(list) {
    const expandedElements = getElementList(list, `.${this.expandedClass}`);

    expandedElements.forEach(expandedElement => {
      expandedElement.classList.remove(this.expandedClass);
    })
  }
}

function getElementList(parent, query) {
  const elements = parent.querySelectorAll(query);
  return Array.from(elements);
}